import service from '@/utils/server';

const modName='/mdm/truck/';
//查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出数据
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportData',
    method: 'post',
    data
  });
};

//添加数据
export const addData = data => {
  return service({
    url: modName + 'addData',
    method: 'post',
    data
  });
};

//删除数据
export const deleteData = data => {
  return service({
    url: modName + 'deleteData',
    method: 'post',
    data
  });
};

//初始化修改
export const initEdit = data => {
  return service({
    url: modName + 'initEdit',
    method: 'post',
    data
  });
};

//修改数据
export const editData = data => {
  return service({
    url: modName + 'editData',
    method: 'post',
    data
  });
};

//模板下载
export const downloadTemplate = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplate/' + data,
    method: 'post',
    data
  });
};

//导入数据
export const importData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'importData',
    method: 'post',
    data
  });
};

export const updateActiveOffFlag = data => {
  return service({
    url: modName + 'updateActiveOffFlag',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/mdm/truck/api/index.js